import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, useFormikContext } from "formik";
import { Dropdown } from "primereact/dropdown";
import { AdvisoryText } from "../../AdvisoryText";

function DropdownComponent(props: any) {
  const { name, label, extendedlabel, Body, isRequired, warnType, warn, ...rest } = props;

  const { setFieldTouched, isSubmitting, setFieldValue } = useFormikContext();
  const [isMismatch, setIsMismatch] = useState(false);

  useEffect(() => {
    if (!isSubmitting) return;
    // clear value if its not part of options after options have changed
    if (
      rest.value != null &&
      typeof rest.value === "string" &&
      rest.value !== "" &&
      !rest.options.some((x: any) => x.value === rest.value || x == rest.value)
    ) {
      setFieldValue(name, "");
    }
    setFieldTouched(name, true, true);
  }, [isSubmitting]);

  // run in 2 render cycles incase options is updatingon same cycle as first useEffect
  useEffect(() => {
    if (
      rest.options != null &&
      rest.options.length > 0 &&
      rest.value != null &&
      typeof rest.value === "string" &&
      rest.value !== "" &&
      !rest.options.some((x: any) => x.value == rest.value || x == rest.value)
    ) {
      setIsMismatch(true);
    }
  }, [rest.value, rest.options]);

  useEffect(() => {
    if (isMismatch) {
      if (
        rest.options != null &&
        rest.options.length > 0 &&
        rest.value != null &&
        typeof rest.value === "string" &&
        rest.value !== "" &&
        !rest.options.some((x: any) => x.value == rest.value)
      ) {
        setFieldValue(name, "");
      }
      setIsMismatch(false);
    }
  }, [isMismatch, rest.value, rest.options]);

  return (
    <div className={`flex flex-col w-full py-2 ${rest.fieldclassname ?? ""}`} id={name.split(".").pop()}>
      {label && (
        <label htmlFor={name} className={isRequired ? "isRequired" : ""}>
          {label}
        </label>
      )}
      {extendedlabel && (
        <div className="helpertext">
          <i>{extendedlabel}</i>
        </div>
      )}
      {Body && (
        <p className="helpertext">
          <i>{<Body />}</i>
        </p>
      )}{" "}
      {warn && <AdvisoryText type={warnType ?? "warn"} label={warn} Body={warn} />}
      <Field alt={name} name={name} {...rest} as={Dropdown} className="rounded-none!" />
      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
export default DropdownComponent;
